export const TOGGLE_NOTIFICATIONS_PANEL_STATE = 'TOGGLE_NOTIFICATIONS_PANEL_STATE';

export const toggleNotificationPanel = (toggle) => ({
  type: TOGGLE_NOTIFICATIONS_PANEL_STATE,
  toggle,
});
